export default __webpack_public_path__ + "static/media/single-user-icon.ff3049b8.svg";